import {z} from 'zod';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

const NON_WHITESPACE_CHARACTER = /\S/;

/**
 * Validates the Name field that edits an item's invoice name.
 * It rejects null, "" and whitespace-only text, which the back end rejects with HTTP 400.
 * It does not trim: the back end stores and prints the text exactly as typed.
 */
export const invoiceNameSchema = z
  .string()
  .nullish()
  .refine(
    (value) => isNotNil(value) && NON_WHITESPACE_CHARACTER.test(value),
    () => ({message: i18n.t('general.errors.mixed.required')})
  );
